export const turnoutParserKey = 'H';
export const isGenericTurnoutCommand = (key, thrownOrKind) => {
    return key === turnoutParserKey && ['0', '1'].includes(thrownOrKind);
};
